export const nginV2Headers = {
  Accept: 'application/vnd.ngin-api.v2, application/json',
  'X-SPORTS-VERSION': 'v1',
}
